import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
// Configuración de notificaciones eliminada

function Configuracion() {
  const [configuraciones, setConfiguraciones] = useState([]);
  const [mensaje, setMensaje] = useState('');
  const [cargando, setCargando] = useState(false);

  const cargarConfiguracion = async () => {
    try {
      const token = localStorage.getItem(config.tokenKey);
      const configRes = await axios.get('/configuracion', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setConfiguraciones(configRes.data);
    } catch (error) {
      console.error('Error cargando configuración:', error);
      setMensaje('Error al cargar la configuración');
    }
  };

  useEffect(() => {
    cargarConfiguracion();
  }, []);

  const handleCambio = (clave, nuevoValor) => {
    setConfiguraciones(prev => 
      prev.map(config => 
        config.clave === clave ? { ...config, valor: nuevoValor } : config
      )
    );
  };

  const guardarConfiguracion = async () => {
    setCargando(true);
    setMensaje('');
    
    try {
      const token = localStorage.getItem(config.tokenKey);
      await axios.put('/configuracion', configuraciones, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setMensaje('✅ Configuración guardada correctamente');
      
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error('Error guardando configuración:', error);
      setMensaje('❌ Error al guardar la configuración');
    } finally {
      setCargando(false);
    }
  };

  const restablecerValores = () => {
    if (window.confirm('¿Estás seguro de que deseas restablecer los valores por defecto?')) {
      setConfiguraciones(prev => prev.map(config => {
        let valorPorDefecto = '';
        switch(config.clave) {
          case 'costo_sesion_30min':
            valorPorDefecto = '40';
            break;
          case 'costo_sesion_45min':
            valorPorDefecto = '50';
            break;
          case 'recordatorio_automatico':
            valorPorDefecto = '24';
            break;
          case 'email_notificaciones':
            valorPorDefecto = '1';
            break;
          default:
            valorPorDefecto = config.valor;
        }
        return { ...config, valor: valorPorDefecto };
      }));
    }
  };

  const renderCampoConfiguracion = (config) => {
    switch(config.tipo) {
      case 'number':
        return (
          <input
            type="number"
            value={config.valor}
            onChange={(e) => handleCambio(config.clave, e.target.value)}
            className="campo-configuracion"
            step="any"
            min="0"
          />
        );
      case 'boolean':
        return (
          <select
            value={config.valor}
            onChange={(e) => handleCambio(config.clave, e.target.value)}
            className="campo-configuracion"
          >
            <option value="1">Activado</option>
            <option value="0">Desactivado</option>
          </select>
        );
      default:
        return (
          <input
            type="text"
            value={config.valor}
            onChange={(e) => handleCambio(config.clave, e.target.value)}
            className="campo-configuracion"
          />
        );
    }
  };

  return (
    <div className="configuracion-page">
      <div className="page-header">
        <h2>Configuración del Sistema</h2>
        <div className="acciones-configuracion">
          <button 
            className="btn-secondary"
            onClick={restablecerValores}
            disabled={cargando}
          >
            🔄 Restablecer
          </button>
          <button 
            className="btn-primary"
            onClick={guardarConfiguracion}
            disabled={cargando}
          >
            {cargando ? '💾 Guardando...' : '💾 Guardar Cambios'}
          </button>
        </div>
      </div>

      {mensaje && (
        <div className={`mensaje ${mensaje.includes('✅') ? 'mensaje-exito' : 'mensaje-error'}`}>
          {mensaje}
        </div>
      )}

      <div className="configuracion-grid">
        {configuraciones.map(config => (
          <div key={config.clave} className="configuracion-card">
            <div className="configuracion-info">
              <h3>
                {config.clave === 'costo_sesion_30min' && '💰'}
                {config.clave === 'costo_sesion_45min' && '💰'}
                {config.clave === 'recordatorio_automatico' && '⏰'}
                {config.clave === 'email_notificaciones' && '📧'}
                {' '}{config.descripcion}
              </h3>
              <p className="clave-configuracion">Clave: {config.clave}</p>
            </div>
            <div className="configuracion-control">
              {renderCampoConfiguracion(config)}
            </div>
          </div>
        ))}
      </div>

      <div className="configuracion-info-adicional">
        <h3>💡 Información Importante</h3>
        <ul>
          <li>Los cambios en los costos de sesión afectarán los cálculos de ingresos estimados</li>
          <li>Los recordatorios se envían automáticamente según la configuración establecida</li>
          <li>La aplicación se recargará automáticamente después de guardar los cambios</li>
        </ul>
      </div>

      {/* Se eliminó la configuración de notificaciones */}
    </div>
  );
}

export default Configuracion;
